import React, {useEffect} from 'react';

import {compose} from 'redux';
import {changeBottomNavigation, changeTitle, showMenuNavBar} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {useMatomo} from "@datapunt/matomo-tracker-react";
import TopoListComponent from "../../components/Route/TopoListComponent";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls} from "../../config/urls";

const TopoListScreen = ({i18n, t, onTitleChange, onBottomNavigationChange, onShowMenuNavBar}) => {
    const { trackPageView } = useMatomo();

    useEffect(() => {
        trackPageView({
            documentTitle: t("App.screens.TopoList.title"), // optional
            href: window.location.pathname,
        });
    }, []);

    useEffect(() => {
        onTitleChange(t("App.screens.TopoList.title"));
        onBottomNavigationChange(true);
        onShowMenuNavBar(true);
    }, [t, onTitleChange, onBottomNavigationChange, onShowMenuNavBar]);

    const canonical = getUrl(PWAUrls.TOPO_LIST, {lng: i18n.language});
    useSEO({title: t("seo.title.topos"), description: t("seo.description.topos")}, canonical);

    return (
        <TopoListComponent />
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
    }
}

export default compose(
    withTranslation(),
    connect(
        null,
        mapDispatchToProps
    )
)(TopoListScreen)
